import '../globalLibraries';
import '../coreLibraries';

import ReactComponentMounter from '../utils/react-component-mounter';
import CookieSettingsForm from '../components/CookieSettingsForm';

ReactComponentMounter.register({
  CookieSettingsForm
});
